import { render, staticRenderFns } from "./freemsg.vue?vue&type=template&id=45a8cb9c&scoped=true&"
import script from "./freemsg.vue?vue&type=script&lang=js&"
export * from "./freemsg.vue?vue&type=script&lang=js&"
import style0 from "./freemsg.vue?vue&type=style&index=0&id=45a8cb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8cb9c",
  null
  
)

export default component.exports